/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Injury_Content_Hero_TitleInputs */

const en_injury_content_hero_title = /** @type {(inputs: Injury_Content_Hero_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Play injury free.`)
};

const es_injury_content_hero_title = /** @type {(inputs: Injury_Content_Hero_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Juega sin lesiones.`)
};

const de_injury_content_hero_title = /** @type {(inputs: Injury_Content_Hero_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verletzungsfrei spielen.`)
};

const zh_injury_content_hero_title = /** @type {(inputs: Injury_Content_Hero_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`打球不伤身。`)
};

const ar_injury_content_hero_title = /** @type {(inputs: Injury_Content_Hero_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`العب بلا إصابات.`)
};

const fr_injury_content_hero_title = /** @type {(inputs: Injury_Content_Hero_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jouer sans blessure.`)
};

const vi_injury_content_hero_title = /** @type {(inputs: Injury_Content_Hero_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chơi không chấn thương.`)
};

const sw_injury_content_hero_title = /** @type {(inputs: Injury_Content_Hero_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cheza bila majeraha.`)
};

const th_injury_content_hero_title = /** @type {(inputs: Injury_Content_Hero_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เล่นกอล์ฟโดยไม่บาดเจ็บ`)
};

const bs_injury_content_hero_title = /** @type {(inputs: Injury_Content_Hero_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Igrajte bez povreda.`)
};

const ja_injury_content_hero_title = /** @type {(inputs: Injury_Content_Hero_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ケガなくプレーする。`)
};

const ko_injury_content_hero_title = /** @type {(inputs: Injury_Content_Hero_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`부상 없이 플레이하세요.`)
};

const pt_injury_content_hero_title = /** @type {(inputs: Injury_Content_Hero_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jogue sem lesões.`)
};

const it_injury_content_hero_title = /** @type {(inputs: Injury_Content_Hero_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gioca senza infortuni.`)
};

const sv_injury_content_hero_title = /** @type {(inputs: Injury_Content_Hero_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spela skadefritt.`)
};

const nl_injury_content_hero_title = /** @type {(inputs: Injury_Content_Hero_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blessurevrij spelen.`)
};

const da_injury_content_hero_title = /** @type {(inputs: Injury_Content_Hero_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spil skadefrit.`)
};

const nb_injury_content_hero_title = /** @type {(inputs: Injury_Content_Hero_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spill uten skader.`)
};

const fi_injury_content_hero_title = /** @type {(inputs: Injury_Content_Hero_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pelaa ilman vammoja.`)
};

const pl_injury_content_hero_title = /** @type {(inputs: Injury_Content_Hero_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Graj bez kontuzji.`)
};

const ru_injury_content_hero_title = /** @type {(inputs: Injury_Content_Hero_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Играйте без травм.`)
};

const tr_injury_content_hero_title = /** @type {(inputs: Injury_Content_Hero_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sakatlanmadan oynayın.`)
};

const hi_injury_content_hero_title = /** @type {(inputs: Injury_Content_Hero_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`चोट-मुक्त खेलें।`)
};

const id_injury_content_hero_title = /** @type {(inputs: Injury_Content_Hero_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bermain tanpa cedera.`)
};

const ms_injury_content_hero_title = /** @type {(inputs: Injury_Content_Hero_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bermain tanpa kecederaan.`)
};

const cs_injury_content_hero_title = /** @type {(inputs: Injury_Content_Hero_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hrajte bez zranění.`)
};

const el_injury_content_hero_title = /** @type {(inputs: Injury_Content_Hero_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Παίξτε χωρίς τραυματισμούς.`)
};

const he_injury_content_hero_title = /** @type {(inputs: Injury_Content_Hero_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`שחקו ללא פציעות.`)
};

const af_injury_content_hero_title = /** @type {(inputs: Injury_Content_Hero_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Speel sonder beserings.`)
};

const hu_injury_content_hero_title = /** @type {(inputs: Injury_Content_Hero_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Játssz sérülésmentesen.`)
};

/**
* | output |
* | --- |
* | "Play injury free." |
*
* @param {Injury_Content_Hero_TitleInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const injury_content_hero_title = /** @type {((inputs?: Injury_Content_Hero_TitleInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Injury_Content_Hero_TitleInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_injury_content_hero_title(inputs)
	if (locale === "de") return de_injury_content_hero_title(inputs)
	if (locale === "zh") return zh_injury_content_hero_title(inputs)
	if (locale === "ar") return ar_injury_content_hero_title(inputs)
	if (locale === "fr") return fr_injury_content_hero_title(inputs)
	if (locale === "vi") return vi_injury_content_hero_title(inputs)
	if (locale === "sw") return sw_injury_content_hero_title(inputs)
	if (locale === "th") return th_injury_content_hero_title(inputs)
	if (locale === "bs") return bs_injury_content_hero_title(inputs)
	if (locale === "ja") return ja_injury_content_hero_title(inputs)
	if (locale === "ko") return ko_injury_content_hero_title(inputs)
	if (locale === "pt") return pt_injury_content_hero_title(inputs)
	if (locale === "it") return it_injury_content_hero_title(inputs)
	if (locale === "sv") return sv_injury_content_hero_title(inputs)
	if (locale === "nl") return nl_injury_content_hero_title(inputs)
	if (locale === "da") return da_injury_content_hero_title(inputs)
	if (locale === "nb") return nb_injury_content_hero_title(inputs)
	if (locale === "fi") return fi_injury_content_hero_title(inputs)
	if (locale === "pl") return pl_injury_content_hero_title(inputs)
	if (locale === "ru") return ru_injury_content_hero_title(inputs)
	if (locale === "tr") return tr_injury_content_hero_title(inputs)
	if (locale === "hi") return hi_injury_content_hero_title(inputs)
	if (locale === "id") return id_injury_content_hero_title(inputs)
	if (locale === "ms") return ms_injury_content_hero_title(inputs)
	if (locale === "cs") return cs_injury_content_hero_title(inputs)
	if (locale === "el") return el_injury_content_hero_title(inputs)
	if (locale === "he") return he_injury_content_hero_title(inputs)
	if (locale === "af") return af_injury_content_hero_title(inputs)
	if (locale === "hu") return hu_injury_content_hero_title(inputs)
	return en_injury_content_hero_title(inputs)
});